import { roundNumber } from "./general";

export const RECOMMENDATION_LOYALTY_POINTS = 100;
export const REVIEW_LOYALTY_POINTS = 30;
export const ENROLLMENT_LOYALTY_POINTS = 50;
export const LOYALTY_POINTS_CONVERSION_RATE_BRONZE = 1;
export const LOYALTY_POINTS_CONVERSION_RATE_SILVER = 1.15;
export const LOYALTY_POINTS_CONVERSION_RATE_GOLD = 1.25;
export const LOYALTY_POINTS_SILVER_THRESHOLD = 2000;
export const LOYALTY_POINTS_GOLD_THRESHOLD = 3000;

export interface RecommendStoreRequestData {
  recommenderEmail: string;
  recommenderName: string;
  recommendedEmail: string;
}

export interface LoyaltyPointsItem {
  ID: string; //accountId
  SK: string; //itemType#date_updated
  accountId: string;
  itemType: "ORDER" | "ENROLLMENT" | "RECOMMENDATION" | "REVIEW";
  loyaltyPointsUsed: number;
  loyaltyPointsGranted: number;
  status: "BLOCKED" | "CONFIRMED" | "DELETED";
  date_updated: number;
  referralData?: {
    orderId?: string;
    email?: string;
    orderNumber?: string;
    productId?: string;
    productName?: string;
    reviewId?: string;
  };
}

export const LOYALTY_DISCOUNT_FACTOR = 0.05;

export const loyaltyPointsToDiscount = (loyaltyPoints: number): number => {
  return roundNumber(loyaltyPoints * LOYALTY_DISCOUNT_FACTOR);
};

export type LoyaltyPointsItemDTO = Pick<LoyaltyPointsItem, "referralData" | "itemType" | "date_updated" | "loyaltyPointsUsed" | "loyaltyPointsGranted" | "status">;
